import { Box, Container, Typography } from "@mui/material";
import { Link } from "react-router-dom";

const RegisterFailed = () => {
  return (
    <Container maxWidth="xs">
      <Box
        sx={{
          marginTop: 8,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Typography variant="h5">登録に失敗しました。</Typography>
        <Link to="/register">再度登録する</Link>
        <Link to="/login">ログインはこちら</Link>
      </Box>
    </Container>
  );
};

export default RegisterFailed;
